"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AccordionMenu = require("./AccordionMenu");
Object.keys(_AccordionMenu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AccordionMenu[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AccordionMenu[key];
    }
  });
});
